import React, { PureComponent } from 'react';

const Aux = props => props.children;
export default Aux;
